import ApiBase from './api_base'
import lodash from 'lodash'

export default class ApisApi {
  static apiInfo(params) {
    return ApiBase.get(params.organization_id ? `/organizations/${params.organization_id}/personal_key` : '/personal_key')
  }

  static updateApiInfo(params) {
    return ApiBase.put(params.organization_id ? `/organizations/${params.organization_id}/personal_key` : '/personal_key', {
      personal_key: lodash.pick(params, ['injected_code', 'ip_whitelist', 'notify_url', 'signing'])
    })
  }

  static sendApplication(params) {
    return ApiBase.post('/api_applications', {
      application: lodash.pick(params, ['name', 'phone', 'company', 'scenario', 'estimate_ppts'])
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/apis.js